import { Card, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const HELP_PAGE_SECTIONS = [
  { id: 'help-quick-start', labelKey: 'help.toc_quick_start' },
  { id: 'help-system-index', labelKey: 'help.toc_system_index' },
  { id: 'help-usage-guide', labelKey: 'help.toc_usage_guide' },
  { id: 'help-faq', labelKey: 'help.toc_faq' },
  { id: 'help-support', labelKey: 'help.toc_support' },
] as const;

export default function HelpTableOfContents() {
  const { t } = useTranslation();

  return (
    <Card className="help-toc shadow-sm">
      <Card.Header className="py-2">
        <strong className="small">{t('help.toc_title')}</strong>
      </Card.Header>
      <Card.Body className="py-2">
        <Nav className="flex-column help-toc-nav">
          {HELP_PAGE_SECTIONS.map((section) => (
            <Nav.Link key={section.id} href={`#${section.id}`} className="py-1 small">
              {t(section.labelKey)}
            </Nav.Link>
          ))}
        </Nav>
      </Card.Body>
    </Card>
  );
}
